import React from "react";
import "../video/video.scss";

const YoutubeVideo = ({ youtube, className = "" }) => {
    // youtube = VIDEO_ID uniquement (ex: "syaXZDpxzs8")
    // Attention : la vidéo doit être en mode "non référençable" (no-cookie) pour éviter les problèmes de lecture sur iOS (WKWebView) et les erreurs de politique de sécurité du contenu (CSP) liées à l'API YouTube dans WKWebView. Assurez-vous que l'URL de la vidéo utilise le domaine "youtube-nocookie.com" et inclut le paramètre "playsinline=1" pour garantir une lecture fluide sur tous les appareils, y compris iOS Chrome/Edge.
    const src = `https://www.youtube-nocookie.com/embed/${youtube}?playsinline=1`;

    return (
        <div className={`video ${className} video--youtube`}>
            <iframe
                src={src} 
                title="YouTube video"
                frameBorder="0"
                allow="encrypted-media; picture-in-picture"
                referrerPolicy="strict-origin-when-cross-origin"
                className='subsection-block__media__video'
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default YoutubeVideo;
